// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PDFSVGViewer{\r\n    width: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n}\r\n.PDFSVGViewer .PDFSVGRoot{\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
